import {
  dropdownContentBase,
  dropdownFormWrapper,
  dropdownItemBase,
  dropdownTriggerBase,
  dropdownTriggerInvalid,
} from '@avanta/shared/components/ui/styles/dropdown';
import { cn } from '@avanta/shared/utils/cn';

export const comboboxWrapper = cn(dropdownFormWrapper, 'notranslate');

export const comboboxTrigger = cn(
  dropdownTriggerBase,
  'relative w-full px-4 py-2 pr-10 data-has-left-icon:pl-10',
  'data-[has-value=false]:text-gray-400',
  dropdownTriggerInvalid
);

export const comboboxContent = cn(
  dropdownContentBase,
  'origin-[--radix-popover-content-transform-origin] p-0',
  'w-(--radix-popover-trigger-width) min-w-(--radix-popover-trigger-width) max-w-(--radix-popover-trigger-width)'
);

export const comboboxItem = cn(
  dropdownItemBase,
  'min-w-0 overflow-hidden rounded-none',
  'hover:bg-plum-100 hover:text-denim-900',
  'data-[selected=true]:bg-transparent',
  'hover:data-[selected=true]:bg-plum-100 hover:data-[selected=true]:text-denim-900'
);
